import { render, staticRenderFns } from "./CRUDContratos.vue?vue&type=template&id=5e6d2f6f&"
import script from "./CRUDContratos.vue?vue&type=script&lang=js&"
export * from "./CRUDContratos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports